import { useRef, useState } from 'react';
import { uploadImageToCloudinary } from './uploadCloudinary';

/**
 * Logique partagée upload photo (Cloudinary) — LivreurPhotoUpload & avatar praticien.
 */
export function useLivreurPhotoUpload({
  onPhotoChange,
  commercantId = null,
  folderBase = 'livreurs',
  disabled = false,
}) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  const handleFile = async (file) => {
    if (disabled || uploading) return;

    if (!file.type.startsWith('image/')) {
      setError('Veuillez sélectionner une image valide');
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError('L\'image ne doit pas dépasser 5 MB');
      return;
    }

    setUploading(true);
    setError('');

    try {
      const folder = commercantId ? `${folderBase}/commercant-${commercantId}` : folderBase;
      const uploadedUrl = await uploadImageToCloudinary(file, folder);
      onPhotoChange(uploadedUrl);
    } catch (err) {
      console.error('Erreur upload photo:', err);
      setError('Erreur lors de l\'upload de la photo. Veuillez réessayer.');
    } finally {
      setUploading(false);
    }
  };

  const handleFileInput = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      await handleFile(e.target.files[0]);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const openFilePicker = () => {
    if (!disabled && !uploading) {
      fileInputRef.current?.click();
    }
  };

  const clearPhoto = () => {
    onPhotoChange('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return {
    uploading,
    error,
    fileInputRef,
    handleFileInput,
    openFilePicker,
    clearPhoto,
    handleFile,
  };
}
